import React, { Component } from 'react';
import { CircularProgress } from 'material-ui-beta/Progress';
import Divider from 'material-ui-beta/Divider';
import Card from 'material-ui-beta/Card';
import Button from 'material-ui-beta/Button';
import numeral from 'numeral';
const ZonedDateTime = require('js-joda').ZonedDateTime;
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui-beta/Dialog';
import Slide from 'material-ui-beta/transitions/Slide';

import StripeApi from '../../api/StripeApi';
import api from '../../api/api';
import ShoppingCartItem from '../../models/ShoppingCartItem';

import './index.css';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class AdminPurhcaseHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            purchases: null,
        };
    }

    componentDidMount() {
        this.fetchPurchases();
    }

    fetchPurchases() {
        api.fetchPurchaseHistory(this.props.user).then(purchases => {
            this.setState({
                loading: false,
                purchases: purchases
            });
        }).catch(err => {
            console.log(err);
            alert('Error fetching purchases');
        })
    }

    isUserAdmin() {
        return this.props.user && this.props.user.isAdmin;
    }

    getCartItems(purchase) {
        return purchase.cart.map((cartItem) => {
            return Object.assign(new ShoppingCartItem(), cartItem);
        });
    }

    render() {
        return (
            <div className="admin-subscriptions-container flex">
                <div className="flex flex1 justifyCenter">
                    {this.state.loading ?
                        <div className="marginTop30">
                            <CircularProgress size={50}/>
                        </div>
                        :
                        <div className="flex column flex1 overflow-y-scroll padding30">
                            {this.state.purchases.map((purchase, index) => {
                                return (
                                    <Purchase
                                        key={`purchase-${index}`}
                                        purchase={purchase}
                                        user={this.props.user}
                                        cartItems={this.getCartItems(purchase)}/>
                                )
                            })}
                            {this.state.purchases.length === 0 ?
                                <div className="lato admin-subscriptions-empty">
                                    No Purchases to Display.
                                </div>
                                :
                                null
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }

}


class Purchase extends Component {

    constructor(props) {
        super(props);

        this.state = {
            subscriptionLoading: -1,
            showDialog: false
        };
    }

    getPurchaseDate() {
        let purchaseDate = ZonedDateTime.parse(this.props.purchase.purchaseDate);
        return `${purchaseDate.monthValue()}/${purchaseDate.dayOfMonth()}/${purchaseDate.year()}`;
    }

    getPrice() {
        return numeral(this.props.purchase.amount / 100.0).format('$0,0.00');
    }

    getRenewalDate(cartItem) {
        let purchaseDate = ZonedDateTime.parse(cartItem.stripe_subscription.created);
        let credits = cartItem.resource.pricing[cartItem.selectedOption].credits;
        let renewalDate = purchaseDate.plusMonths(credits);
        return `Renews ${renewalDate.monthValue()}/${renewalDate.dayOfMonth()}/${renewalDate.year()}`;
    }

    onCancelClick = (cartItem, index) => {
        this.setState({
            subscriptionLoading: index,
            showDialog: true
        });
    };

    handleClose = (event) => {
        this.setState({
            subscriptionLoading: -1,
            showDialog: false
        });
    };

    onConfirmClick = (event) => {
        this.setState({
            showDialog: false
        });
        // console.log("cancel subscription", this.props.purchase.cart[this.state.subscriptionLoading].stripe_subscription);
        StripeApi.cancelSubscription(this.props.purchase.cart[this.state.subscriptionLoading].stripe_subscription.id).then(confirmation => {
            api.removeSubscription(this.props.user, this.props.purchase, this.state.subscriptionLoading).then(() => {
                this.props.cartItems[this.state.subscriptionLoading].stripe_subscription = null;
                this.setState({
                    subscriptionLoading: -1
                });
            });
        }).catch(err => {
            alert('error cancelling subscription');
            this.setState({
                subscriptionLoading: -1
            });
        });
    };

    render() {
        return (
            <div className="admin-subscription-container flex1">
                <Card className="admin-subscription-card padding30 marginTop20">
                    <div className="flex">
                        <div className="flex1 oswald admin-subscription-title">
                            {this.getPurchaseDate()}
                        </div>
                        <div className="lato admin-subscription-price">
                            {this.getPrice()}
                        </div>
                    </div>
                    {this.props.cartItems.map((cartItem, index) => {
                        return (
                            <div key={"cart-item-" + index}>
                                <div className="cart-item-container">
                                    <div className="flex">
                                        <div className="flex1">
                                            <div className="cart-item-title oswald">
                                                {cartItem.resource.title}
                                            </div>
                                            <div className="cart-item-subtitle lato">
                                                {cartItem.resource.pricing[cartItem.selectedOption].title}
                                            </div>
                                        </div>
                                        <div className="cart-item-total lato">
                                            {numeral(cartItem.getTotal() / 100.0).format('$0,0.00')}
                                        </div>
                                    </div>
                                    {cartItem.locations ?
                                        <div className="cart-item-locations oswald">
                                            {cartItem.locations.map(location => { return location.name }).join(" • ")}
                                        </div>
                                        :
                                        null
                                    }
                                    {cartItem.stripe_subscription ?
                                        <div className="marginTop15 oswald cart-item-subtitle">
                                            {this.state.subscriptionLoading === index ?
                                                <CircularProgress size={35}/>
                                                :
                                                <div>{this.getRenewalDate(cartItem)} <Button onClick={this.onCancelClick.bind(null, cartItem, index)} color="secondary">Cancel Subscription</Button></div>
                                            }
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                                {index < this.props.cartItems.length - 1 ?
                                    <Divider />
                                    :
                                    null
                                }
                            </div>
                        )
                    })}
                    <div className="admin-subscription-renews lato marginTop15">
                        Purchased by &lt;{this.props.purchase.user.email}&gt;
                    </div>
                </Card>
                <Dialog
                    open={this.state.showDialog}
                    transition={Transition}
                    onClose={this.handleClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Confirm Cancellation
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            Are you sure you want to cancel this Subscription?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">Cancel</Button>
                        <Button onClick={this.onConfirmClick} color="primary">Confirm</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }


}

export default AdminPurhcaseHistory;


// WEBPACK FOOTER //
// ./src/components/admin-purchase-history/index.js